/**
 * Orders the instance selector's cards: favorites first, then the rest. Within each group the
 * most recently entered leads; the last-used instance always leads its group, even if it
 * predates the last-access map. Instances this browser never entered keep the API order
 * (Array.prototype.sort is stable).
 *
 * @param instances The page of instances as the API returned it
 * @param lastAccessById Last-entry timestamp per instance id, tracked per browser
 * @param lastUsedId Id of the instance entered last, or null
 */
export function orderInstances<T extends { id: string; isFavorite?: boolean }>(
  instances: T[],
  lastAccessById: Record<string, number>,
  lastUsedId: string | null
): T[] {
  const recencyOf = (item: T): number =>
    item.id === lastUsedId ? Number.POSITIVE_INFINITY : (lastAccessById[item.id] ?? 0);
  return [...instances].sort(
    (first, second) =>
      Number(!!second.isFavorite) - Number(!!first.isFavorite) ||
      recencyOf(second) - recencyOf(first)
  );
}
